import Http from './base-http'

class Scheduling extends Http {
  sendEmailWeeklyWorkSchedulesToEmployees(data) {
    return this.client
      .post(`sendweeklyworkscheduleemails/${data.storeId}`, data)
  }
  sendSmsWeeklyWorkSchedulesToEmployees(data) {
    return this.client
      .post(`sendweeklyworkschedulesms/${data.storeId}`, data)
  }
}

const scheduling = new Scheduling({
  modelUrlPrefix : 'process/scheduling'
})

export default scheduling
